import React from 'react';
export function HeaderV2() {
  return <header className="bg-white border-b border-gray-200" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="flex items-center h-16" data-id="element-18">
          <img src="https://cdn.magicpatterns.com/uploads/6mo6ZdRQSELdPGB9Db4jao/ofri-anniversary-logo-3735114f9ba0bd97.svg" alt="Ofri – 10 Jahre" className="h-6 sm:h-[28px] w-auto" data-id="element-19" />
        </div>
      </div>
    </header>;
}